import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
//redux
import { useDispatch, useSelector } from "react-redux";
import { Eye, EyeOff } from "lucide-react";
import { Button } from "components/ui";
import AuthLayout from "components/AuthLayout/AuthLayout";

import { actions } from "../../redux/User/action";
import { takePostLoginPath } from "utils/postLogin";
import MfaLoginStep from "../Mfa/MfaLoginStep";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [thirdpartyloading, setThirdPartyLoading] = useState(false); 

  const { error: loginError, mfa } = useSelector((state) => state.user);

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (event) => {
    // Clear error when user starts typing
    if (error) {
      setError("");
      dispatch({
        type: actions.CATCH_ERROR,
        payload: "",
      });
    }
    setLoginData((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Clear previous error
    setError("");
    dispatch({
      type: actions.CATCH_ERROR,
      payload: "",
    });
    
    const errors = !loginData?.email || !loginData?.password;
    if (errors) {
      setError("Enter your email and password.");
    } else {
      setIsLoading(true);
      dispatch(
        actions.userLogin(
          { email: loginData?.email, password: loginData?.password },
          navigate
        )
      );
    }
  };

  useEffect(() => {
    if (!mfa) setIsLoading(false);
  }, [mfa]);

  useEffect(() => {
    setError(loginError);
    if (loginError) {
      setIsLoading(false);
    }
    // setTimeout(function () {
    //   setError("");
    // }, 10000);
  }, [loginError]);

  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const auth = params.get("auth");
  const email = params.get("email");
  const id = params.get("id");

  if (auth === "3rdparty" && email && id) {
    setThirdPartyLoading(true); // Start loading
    fetch(process.env.REACT_APP_USER_BASE_URL + "/tutor/ssologin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, id }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to authenticate");
        }
        return response.json();
      })
      .then((data) => {
        localStorage.setItem("TOKEN", data.result.token);
        localStorage.setItem(
          "REFRESH_TOKEN",
          data.result.refreshToken
        );
        
        navigate(takePostLoginPath());
      })
      .catch((err) => {
        setError("3rd party login failed: " + err.message);
      })
      .finally(() => {
       // setThirdPartyLoading(false); // End loading
      });
  }
}, []);


  if (mfa) {
    return (
      <AuthLayout>
        <MfaLoginStep />
      </AuthLayout>
    );
  }

  if (thirdpartyloading) {
    return (
      <AuthLayout title="Signing you in" description="One moment…">
        <div className="cc-auth__center">
          <span className="cc-spinner" aria-hidden="true" style={{ width: 28, height: 28 }} />
        </div>
        {error && <p className="cc-field__error" role="alert">{error}</p>}
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Sign in" description="Enter your details to open the Control Centre.">
      <form onSubmit={handleSubmit} className="cc-stack" noValidate>
        <label className="cc-field">
          <span className="cc-field__label">Email address</span>
          <input
            className="cc-input"
            type="email"
            id="tutorEmail"
            name="email"
            autoComplete="username"
            value={loginData?.email}
            onChange={handleChange}
          />
        </label>
        <div className="cc-field">
          <span className="cc-field__label">Password</span>
          <div className="cc-input-group">
            <input
              className="cc-input"
              name="password"
              id="tutorPassword"
              type={showPassword ? "text" : "password"}
              autoComplete="current-password"
              value={loginData?.password}
              onChange={handleChange}
            />
            <Button
              type="button"
              variant="ghost"
              size="sm"
              iconOnly
              icon={showPassword ? EyeOff : Eye}
              className="cc-icon-btn"
              style={{ width: "auto" }}
              aria-label={showPassword ? "Hide password" : "Show password"}
              onClick={() => setShowPassword(!showPassword)}
            />
          </div>
        </div>
        {error && (
          <p id="login_validation" className="cc-field__error" role="alert">
            {error}
          </p>
        )}
        <div className="cc-auth__row">
          <Link to="/auth/forgot-password" className="cc-auth__link">
            Forgot password?
          </Link>
        </div>
        <Button type="submit" variant="primary" loading={isLoading}>
          Sign in
        </Button>
      </form>
    </AuthLayout>
  );
}

export default Login;
